import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    IconButton,
    List,
    ListItem,
    makeStyles,
    Menu,
    MenuItem,
    Typography,
} from "@material-ui/core"
import { Add, ExpandMore, MoreVert } from "@material-ui/icons"
import { memo, useCallback, useMemo, useState } from "react"
import { useCardapioContext } from "./CardapioContext"
import ItemProduto from "./ItemProduto"

const ITEM_HEIGHT = 48

const useStyles = makeStyles(() => ({
    container: {
        width: "100%",
    },
    accordion: {
        width: "100%",
    },
    cadastrarProduto: {
        height: "50px",
        display: "flex",
        justifyContent: "center",
    },
    lista: {
        width: "100%",
    },
    dragIndicator: {
        cursor: "move",
    },
}))

const Categorias = memo(function Categorias({ index, categoria }) {
    const {
        setOpenproduto,
        setOpenCategoria,
        setCadastrar,
        setModalCategoria,
        setModalProduto,
        setCategoriaAtual,
        handleDuplicarCategoria,
        handleExcluirCategoria,
    } = useCardapioContext()

    const [anchorEl, setAnchorEl] = useState(null)
    const [openAcordion, setOpenAcordion] = useState(false)

    const classes = useStyles()

    const handleAccordionToggle = useCallback(() => {
        setCategoriaAtual(categoria)
        setOpenAcordion(prevOpen => !prevOpen)
    }, [categoria, setCategoriaAtual])

    const handleClickMoreItemDeMontagem = useCallback(e => {
        setAnchorEl(e.currentTarget)
        e.stopPropagation()
    }, [])

    const handleCloseMoreItemDeMontagem = useCallback(e => {
        setAnchorEl(null)
        e.stopPropagation()
    }, [])

    const produtosOrdenados = useMemo(() => {
        if (!openAcordion) return []
        const p = categoria?.produtos ?? []
        return [...p].sort((a, b) => a.ordemExib - b.ordemExib)
    }, [categoria?.produtos, openAcordion])

    return (
        <div className={classes.container}>
            <Accordion
                className={classes.accordion}
                expanded={openAcordion}
                onChange={handleAccordionToggle}
            >
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Grid container alignItems="center">
                        <Typography>{categoria.nome}</Typography>
                    </Grid>
                    <IconButton onClick={handleClickMoreItemDeMontagem}>
                        <MoreVert fontSize="small" />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleCloseMoreItemDeMontagem}
                        PaperProps={{
                            style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                                width: "20ch",
                            },
                        }}
                    >
                        <MenuItem
                            onClick={e => {
                                setOpenCategoria(true)
                                setCadastrar(false)
                                setModalCategoria(categoria)
                                e.stopPropagation()
                            }}
                        >
                            Editar Categoria
                        </MenuItem>
                        <MenuItem
                            onClick={e => {
                                e.stopPropagation()
                                setCadastrar(true)
                                handleDuplicarCategoria(categoria.id)
                            }}
                        >
                            Duplicar Categoria
                        </MenuItem>
                        <MenuItem
                            onClick={e => {
                                e.stopPropagation()
                                handleExcluirCategoria(categoria.id)
                            }}
                        >
                            Excluir Categoria
                        </MenuItem>
                    </Menu>
                </AccordionSummary>
                {openAcordion && (
                    <AccordionDetails>
                        <List className={classes.lista} fullWidth>
                            <ListItem className={classes.cadastrarProduto}>
                                <Typography>Cadastrar Produto</Typography>
                                <IconButton aria-label="Add" size="small">
                                    <Add
                                        fontSize="large"
                                        onClick={() => {
                                            setCategoriaAtual(categoria)
                                            setOpenproduto(true)
                                            setCadastrar(true)
                                            setModalProduto(null)
                                        }}
                                    />
                                </IconButton>
                            </ListItem>
                            {produtosOrdenados.map(produto => (
                                <ListItem key={produto.id} divider>
                                    <ItemProduto conteudo={produto} categoria={categoria} />
                                </ListItem>
                            ))}
                        </List>
                    </AccordionDetails>
                )}
            </Accordion>
        </div>
    )
})

export default Categorias
